import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";

// ui
import { LabeledTextFieldForm } from "@/components/Combines/Form/LabeledTextFieldForm";
import { SubmitButton } from "@/components/Elements/Inputs";
import { VStack } from "@/components/Elements/Layouts";

// state
import { adminState } from "@/store/adminState";
import { Box } from "@mui/material";

// types
import { ID, PASSWORD } from "./types";

interface IForm {
  id: string;
  password: string;
}

export const Login = () => {
  //
  const [admin, setAdmin] = useRecoilState(adminState);

  // react-hook-form
  const form = useForm<IForm>({
    mode: "onChange",
    defaultValues: {
      id: "",
      password: "",
    },
  });
  const {
    formState: { isValid },
    handleSubmit,
  } = form;

  return (
    <Box
      sx={{
        // margin: "30px",
        padding: "30px",
        backgroundColor: "#fff",
      }}
    >
      <VStack spacing={3} alignItems="flex-start">
        <h1>ログイン画面</h1>
        <>パスワードをご入力の上、「ログイン」ボタンをクリックしてください。</>
        <LabeledTextFieldForm
          required
          form={form}
          label="ID"
          name="id"
          type="text"
        />
        <LabeledTextFieldForm
          required
          form={form}
          label="Password"
          name="password"
          type="password"
        />
        <SubmitButton
          label="ログイン"
          disabled={!isValid}
          onClick={handleSubmit((d) => {
            if (d.id !== ID) return;
            if (d.password !== PASSWORD) return;
            setAdmin({ doneLogin: true });
          })}
        />
      </VStack>
    </Box>
  );
};
